import { Component, OnDestroy, ViewChild } from "@angular/core";
import { HeaderComponent } from "app/shared/components/header/header.component";
import { SidenavComponent } from "app/shared/components/sidenav/sidenav.component";
import { FooterComponent } from "app/shared/components/footer/footer.component";
import { AutoReloadComponent } from "app/shared/components/auto-reload/auto-reload.component";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatToolbar } from "@angular/material/toolbar";
import { PageContentComponent } from "app/shared/components/page-content/page-content.component";
import { RouterOutlet } from "@angular/router";
import { UserInfoComponent } from "app/shared/components/user-info/user-info.component";
import { SidenavMode } from "app/shared/models/sidenav-mode.type";
import { Subject } from "rxjs";
import { BreakpointService } from "app/core/services/breakpoint.service";
import { LanguageService } from "app/core/services/language.service";
import { TranslateService } from "@ngx-translate/core";
import { LoaderService } from "app/shared/components/loader/loader.service";
import { takeUntil } from "rxjs/operators";
import { BreakpointState } from "@angular/cdk/layout";
import { UserSettingsDrawerService } from "app/shared/components/user-settings-drawer/user-settings-drawer.service";
import { NconnectVoiceModule } from "../nconnect-voice/nconnect-voice.module";
import { UnsupportedBrowserService } from "app/core/services/unsupported-browser.service";

@Component({
  selector: "main-container",
  templateUrl: "./main-container.component.html",
  styleUrls: ["./main-container.component.scss"],
  imports: [
    HeaderComponent,
    SidenavComponent,
    FooterComponent,
    AutoReloadComponent,
    MatSidenav,
    MatSidenavContainer,
    MatToolbar,
    PageContentComponent,
    RouterOutlet,
    UserInfoComponent,
    // NconnectVoiceModule
  ],
})
export class MainContainerComponent implements OnDestroy {
  @ViewChild("sidenav", { static: false }) public sidenav?: MatSidenav;
  // public isUserSettingsShown: boolean = false;
  public isSidenavOpen: boolean;
  public sidenavMode: SidenavMode = "side";
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private breakpointService: BreakpointService,
    private languageService: LanguageService,
    private translateService: TranslateService,
    private loaderService: LoaderService,
    private userSettingsDrawerService: UserSettingsDrawerService,
    private unsupportedBrowserService: UnsupportedBrowserService,
  ) {
    this.loaderService.hide();

    this.languageService.updateLanguage(
      this.languageService.getCurrentLanguage(),
    );

    this.translateService.use(this.languageService.getCurrentLanguage());
    this.translateService.setDefaultLang("en");
    this.languageService.setHtmlLang();

    this.setSidenavOptions();
    this.openUnsupportedBrowserModal();
  }

  public toggleUserSettings(): void {
    this.userSettingsDrawerService.toggle();
  }

  public toggleSidenav(): void {
    this.sidenav?.toggle();
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private setSidenavOptions(): void {
    this.breakpointService
      .getBreakpointState("(min-width: 1280px)")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((breakpointState: BreakpointState) => {
        const sidenavMode: SidenavMode = breakpointState.matches
          ? "side"
          : "over";
        this.sidenavMode = sidenavMode;
        this.isSidenavOpen = sidenavMode === "side";
      });
  }

  private openUnsupportedBrowserModal(): void {
    this.unsupportedBrowserService.showUnsupportedBrowserModal();
  }
}
